module.exports = __webpack_public_path__ + "img/logo-rtl.42e61081.svg";